/** Match backend RankSnapshotInterval (15 minutes). */
export const LEADERBOARD_POLL_MS = 15 * 60 * 1000;

/** Refresh scoreboard and match results while the page is open. */
export const SCOREBOARD_POLL_MS = 5 * 60 * 1000;
